// extracted by mini-css-extract-plugin
export default {"wrapper_articleControl":"ArticleControl_wrapper_articleControl__JDNDT","wrapper_body":"ArticleControl_wrapper_body__pYi5o"};